var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable } from "mobx";
import { buildWebsiteUrl, WebsiteURL } from "healthex-common/websiteurls";
import { i18nGetCurrentLanguage } from "../Infra/i18next";
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export class ForgotPasswordViewModel {
    constructor(container) {
        var _a, _b;
        this.email = "";
        this.emailSent = false;
        this.organizationId = null;
        this.environment = container.environment;
        this.authManager = container.authManager;
        this.organizationId = (_b = (_a = container.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.organizationId) !== null && _b !== void 0 ? _b : null;
    }
    get isEmailValid() {
        return EMAIL_REGEX.test(this.email);
    }
    updateEmail(email) {
        this.email = email;
    }
    async requestPasswordReset() {
        var _a;
        if (!this.email)
            return;
        await this.authManager.sendPasswordResetUrl(this.email, (_a = this.organizationId) !== null && _a !== void 0 ? _a : undefined);
        this.emailSent = true;
    }
    enterNewEmail() {
        this.emailSent = false;
        this.organizationId = null;
    }
    contactUsToJoin() {
        window.open(buildWebsiteUrl(WebsiteURL.CONTACT_US, this.environment.WEBSITE_BASE_URL, i18nGetCurrentLanguage()));
    }
}
__decorate([
    observable
], ForgotPasswordViewModel.prototype, "email", void 0);
__decorate([
    observable
], ForgotPasswordViewModel.prototype, "emailSent", void 0);
__decorate([
    observable
], ForgotPasswordViewModel.prototype, "organizationId", void 0);
__decorate([
    computed
], ForgotPasswordViewModel.prototype, "isEmailValid", null);
